// Include React
var React = require("react");

var Sidenav = React.createClass({
    render: function(){
        return(

            <div className="nav-wrapper">
                <ul id="nav-mobile" className="side-nav">
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About</a></li>
                    <li><a href="#projects">Projects</a></li>
                    <li><a href="#contact">Contact</a></li>
                </ul>

            </div>


        );
    }
});

module.exports = Sidenav;


// WEBPACK FOOTER //
// ./src/components/children/sidenav.js